// ─── MSAL Authentication Configuration ───────────────────────────────────────
// Uses the H2 Fin Portal app registration — no separate registration needed.
// The portal token carries through; no second sign-in required for users
// already authenticated in the H2 Fin Portal.
//
// Tenant ID and Client ID are injected at build time via GitHub Actions secrets
// and are never committed to the repository.

const TENANT_ID = process.env.REACT_APP_TENANT_ID;
const CLIENT_ID = process.env.REACT_APP_PORTAL_CLIENT_ID;

export const msalConfig = {
  auth: {
    clientId:    CLIENT_ID,
    authority:   `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: {
    // sessionStorage: token cleared when browser tab closes.
    // Do NOT use localStorage here — that would persist the token
    // across sessions on shared machines.
    cacheLocation:          "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

// Scopes requested at login. openid/profile/email are standard OIDC.
// User.Read allows reading the signed-in user's profile from MS Graph
// (display name, job title, etc.) without additional admin consent.
export const loginRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
};

// Roles defined in the H2 Fin Portal app manifest.
// Branch role is blocked at the portal nav level and never reaches this app.
export const APP_ROLES = {
  ADMIN:   "Admin",
  ADVISOR: "Advisor",
};
